var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.583,
    height: 17.097,
    viewBox: "0 0 19.583 17.097",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fff}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3564",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8325",
    d: "M1955.4 750.749h.014a1.888 1.888 0 0 0 1.38-.6l2.627 1.014a1.877 1.877 0 1 0 3.72-.483l3.125-2.15a1.841 1.841 0 0 0 .884.227 1.878 1.878 0 0 0 0-3.756 1.891 1.891 0 0 0-1.878 1.878 1.841 1.841 0 0 0 .115.63l-2.913 2a1.867 1.867 0 0 0-2.41.028 1.985 1.985 0 0 0-.294.324l-2.462-.953v-.037a1.892 1.892 0 0 0-1.877-1.9h-.013a1.89 1.89 0 0 0-.013 3.78zm.411-1.5a.529.529 0 0 1-.378.157.539.539 0 0 1-.536-.539.518.518 0 0 1 .155-.377.532.532 0 0 1 .375-.159h.009a.538.538 0 0 1 .537.535.535.535 0 0 1-.166.384zm5.854 2.094a.536.536 0 0 1-.378.156.54.54 0 0 1-.536-.54.531.531 0 0 1 .525-.532h.012a.537.537 0 0 1 .378.916zm6.017-4.464a.529.529 0 0 1-.156.378.536.536 0 0 1-.38.157.536.536 0 0 1-.013-1.073h.014a.539.539 0 0 1 .532.538z",
    className: "cls-1",
    transform: "translate(-1951.47 -745)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8326",
    d: "M1970.922 759.378h-1.252V749.8a.665.665 0 0 0-.67-.674l-2.69.005a.672.672 0 0 0-.673.668v9.574h-1.826v-5.363a.654.654 0 0 0-.192-.476.666.666 0 0 0-.476-.2h-2.693a.672.672 0 0 0-.671.67v5.373h-1.829V751.9a.674.674 0 0 0-.672-.667h-2.693a.672.672 0 0 0-.666.67v7.471h-1.21a.681.681 0 0 0-.49.157.668.668 0 0 0-.235.455.685.685 0 0 0 .682.727h18.255a.671.671 0 0 0 0-1.341zm-14.305-6.8v6.8h-1.355v-6.8zm4.5 6.8v-4.7h1.351v4.7zm5.859 0v-8.9h1.351v8.9z",
    className: "cls-1",
    transform: "translate(-1951.983 -743.621)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.d018c894.svg";
export { ForwardRef as ReactComponent };